// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"


const SectionLoading: React.FC<{fullheight?: boolean}> = ({
  fullheight
}) => {
  return (
    <div
      style={{
        alignItems: "center",
        height: (!!fullheight) ? "var(--section-content-height)" : "unset",
        justifyContent: "center",
        display: "flex",
        width: "100%"
      }}
    >
      <FontAwesomeIcon icon={faSpinner} spin size="2x"/>
    </div>
  )
}


export default SectionLoading